var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 80,
    viewBox: "0 0 86 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7364 2.06978C45.2747 -0.689928 40.7292 -0.689928 39.2675 2.06978L1.24692 73.8054C0.904669 74.4484 0.734994 75.1689 0.75443 75.8969C0.773867 76.6248 0.981752 77.3353 1.35783 77.9591C1.73391 78.583 2.26536 79.0988 2.90038 79.4565C3.53541 79.8142 4.25237 80.0014 4.98139 80H81.0225C81.751 80.0015 82.4675 79.8144 83.1021 79.457C83.7367 79.0995 84.2677 78.5839 84.6434 77.9605C85.0191 77.337 85.2267 76.6269 85.2459 75.8994C85.265 75.172 85.0951 74.452 84.7528 73.8096L46.7364 2.06978ZM47.2265 67.3408H38.7774V58.9013H47.2265V67.3408ZM38.7774 50.4618V29.3631H47.2265L47.2307 50.4618H38.7774Z",
    fill: "#567BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOk);
export default __webpack_public_path__ + "static/media/error-ok.e4e2ba1e3c774a4ca694a9319a2f7c8b.svg";
export { ForwardRef as ReactComponent };